import { useEffect } from "react";

const useForceLightMode = () => {
  useEffect(() => {
    const root = document.documentElement;
    const body = document.body;
    const hadDarkClass = root.classList.contains("dark");
    const previousRootColorScheme = root.style.colorScheme;
    const previousBodyColorScheme = body?.style?.colorScheme ?? "";

    root.classList.remove("dark");
    if (body) {
      body.classList.remove("dark");
    }

    root.style.colorScheme = "light";
    if (body) {
      body.style.colorScheme = "light";
    }

    return () => {
      root.style.colorScheme = previousRootColorScheme;
      if (body) {
        body.style.colorScheme = previousBodyColorScheme;
      }

      const prefersDarkMode = localStorage.getItem("darkMode") === "true";
      if (hadDarkClass || prefersDarkMode) {
        root.classList.add("dark");
      } else {
        root.classList.remove("dark");
      }
    };
  }, []);
};

export default useForceLightMode;
